import { render, staticRenderFns } from "./CommonFooterV2.vue?vue&type=template&id=8034785c&scoped=true&"
import script from "./CommonFooterV2.vue?vue&type=script&lang=js&"
export * from "./CommonFooterV2.vue?vue&type=script&lang=js&"
import style0 from "./CommonFooterV2.vue?vue&type=style&index=0&id=8034785c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8034785c",
  null
  
)

export default component.exports